import {Step, Stepper} from 'react-form-stepper';
import {Header, Text} from "react-aria-components";
import React from "react";
import "./OnboardingSSteps.css"


const step1Description = "Sign up for an account to manage the Databases, proxies, and filters."
const step2Description = "Define a Database to host your proxy. You can use a cloud provider or your own postgres Database."
const step3Description = "Create an API key to give your veilstream proxy."
const step4Description = "Start an veilstream proxy. The proxy will describe the schema of your database, so you can design filters for it."
const step5Description = "Create filters to restrict the .data that your proxy will return."
const step6Description = "Verify that your proxy is working correctly by making a request to it."


function SetupProgress(props: { label: string, description: string }) {
    return null;
}

function OnboardingSteps({completedSteps = [0, 1]}: {completedSteps: number[]}) {
    let maxCompletedStep = 0;
    completedSteps.forEach(step => {
        if(step > maxCompletedStep) {
            maxCompletedStep = step
        }
    })
    const [selectedStep, setSelectedStep] = React.useState(maxCompletedStep)


    const steps = [
        {label:"Sign Up", description:step1Description},
        {label:"Define a Database", description:step2Description},
        {label:"Create an API Key", description:step3Description},
        {label:"Start a Proxy", description:step4Description},
        {label:"Create Filters", description:step5Description},
        {label:"Verify Proxy", description:step6Description},
    ]
    steps.forEach((step, index) => {
        steps[index].index = index
        steps[index].onClick = () => {
            setSelectedStep(index)
        }
        steps[index].completed = completedSteps.includes(index)
        steps[index].active = selectedStep === index
    })

    console.log(selectedStep, steps[selectedStep])

    return <div className="onboarding-steps">
        <SetupProgress label="Sign Up" description={step1Description}/>
        <Stepper activeStep={selectedStep}>
            {steps.map(step => {
                return <Step
                    {...step}
                    key={"step_"+step.index}
                />
            })}
        </Stepper>
        <div className="step-details">
            <Header className="title">{steps[selectedStep].label}</Header>
            <Text className="description">{steps[selectedStep].description}</Text>
        </div>
    </div>
}

export default OnboardingSteps